import {
  Action, Dispatch, Middleware,
} from 'redux';
import { service } from '@src/service/index.js';
import { SET_EDIT_ACTIVE_GROUP_IND, CANCEL_EDIT_MODE } from '@src/store/consents.js';
import type { RootState } from '@src/store/index.js';

export const scroller: Middleware<unknown, RootState> = () => (next) => (action) => {
  const ret = next(action) as Dispatch;
  const { type } = action as Action<string>;

  if (type === SET_EDIT_ACTIVE_GROUP_IND || type === CANCEL_EDIT_MODE) {
    service.scrollToTop();
  }
  return ret;
};
